import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=574ea539&scoped=true"
import script from "./checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkbox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=574ea539&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ea539",
  null
  
)

export default component.exports